const hintsList = {
    graph_nodes: {
        hint: `Click the nodes in the graph to explore the context and relations between ideas. Hide them to reveal latent topics.`,
        target_id: 'graph-container',
        position: { x: 50, y: 50 },
    },
    analytics_intro: {
        hint: `Use this panel to get the insights about the main topics, ideas, and gaps in this discourse as well as the AI-generated summary.`,
        target_id: 'analyticsCaption',
        position: { x: 0, y: 50 },
    },
    analytics_button: {
        hint: `Click this button to get analytical insights about this text.`,
        target_id: 'analyticsbutton',
        position: { x: 0, y: 0 },
    },
    show_topics: {
        hint: `Toggle this switch show / hide the names for the main topical clusters identified in this discourse.`,
        target_id: 'categoryToggle',
        position: { x: 50, y: -20 },
    },
    ai_insights: {
        hint: `Open the AI panel to generate new ideas and get a guided assistance with graph exploration.`,
        target_id: 'aibutton',
        position: { x: 100, y: 0 },
    },
    filter_panel: {
        hint: `Use the filter panel to generate graphs by your import categories, search queries, or sentiment. Then generate a precise AI summary of your filtered data based on the graph structure and content.`,
        target_id: 'categoryFilterButton',
        position: { x: 0, y: 120 },
    },
    delete_nodes: {
        hint: `You can hide the nodes you selected to reveal underlying ideas and latent topics.`,
        target_id: 'deletenodes',
        position: { x: 50, y: 120 },
    },
    unhide_nodes: {
        hint: `You can return the hidden nodes back into the graph or save them in the permanent stopwords list to never see them again in this graph.`,
        target_id: 'removestopwords',
        position: { x: 50, y: 120 },
    },
}

export default hintsList
